import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
  ) { }

  handleError(error: any) {
    console.error('Toast error handler presenting error', error);

    const toastService = this.injector.get(ToastrService);

    const { title, message } = this.formatError(error);

    if(message.includes('NG04012')) {
      window.location.reload();
      return;
    }

    if(message.includes('NG0100')) {
      return;
    }

    toastService.error(message, title, {
      disableTimeOut: true,
      onActivateTick: true,
    });
  }

  formatError(error: any): { title?: string|null; message: string } {
    if (error?.rejection) {
      error = error.rejection;
    }

    if (error instanceof HttpErrorResponse) {
      return {
        message: error.error.message ?? error.message,
      };
    }

    if (typeof error === 'object') {
      return {
        title: 'Error',
        message: error.message ?? error.toString(),
      };
    }

    if (typeof error == 'string') {
      return {
        title: 'Error',
        message: error,
      };
    }

    return {
      title: 'Error',
      message: 'Unknow error',
    };
  }

}
